import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import { addNewObject } from "../../../../Loaders"
import PageLoadingPanel from "../../../../shared_components/widgets/PageLoadingPanel"
import AddEntityForm from "./AddEntityForm"
import { handleError } from "./utils"

export default function NewProjectForm({
  getTextStr,
  onSuccess,
  projectManagerField,
  permission,
  disabled = false,
}) {
  const [projectForm, setProjectForm] = useState({})
  const setDefaultProject = () =>
    setProjectForm({
      ...{ name: "", description: "", netsuite_project_id: "" },
      project_manager_id: projectManagerField?.defaultOpt?.id,
    })
  useEffect(() => {
    setDefaultProject()
  }, [])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [creatingProject, setCreatingProject] = useState(false)
  const handleCreateProject = (e) => {
    e.preventDefault()
    setLoading(true)
    addNewObject("/warehouse/projects/", projectForm, true)
      .then((proj) => {
        setLoading(false)
        setDefaultProject()
        setCreatingProject(false)
        onSuccess(String(proj.id))
      })
      .catch((err) => {
        setLoading(false)
        handleError(err, setError)
      })
  }

  return (
    <>
      {loading ? (
        <PageLoadingPanel />
      ) : (
        projectForm?.project_manager_id && (
          <div className={"mt-3"}>
            <Button
              variant={"outline-primary"}
              size={"sm"}
              disabled={disabled || !permission}
              onClick={() => setCreatingProject(!creatingProject)}
            >
              <span className={creatingProject ? "fa fa-caret-down" : "fa fa-caret-right"} />
              &nbsp;
              <span className={"fa fa-plus-circle"} />
              &nbsp;
              {`${getTextStr("general.add", "Add")}: ${getTextStr("general.project", "Project")}`}
            </Button>
            {creatingProject && (
              <AddEntityForm
                getTextStr={getTextStr}
                onSubmit={handleCreateProject}
                entityForm={projectForm}
                setValue={(key, val) => {
                  setProjectForm({ ...projectForm, [key]: val })
                  error && setError(null)
                }}
                extraRows={[
                  {
                    id: "fermmanagement.netsuite.project.id",
                    msg: "Netsuite Project ID",
                    key: "netsuite_project_id",
                    type: "input",
                  },
                  projectManagerField,
                ]}
                error={error}
                disabled={!permission || loading}
              />
            )}
          </div>
        )
      )}
    </>
  )
}
